import {validEmail,normalizePhone} from './contact-detail-policy';
const rules={
  "dateLabels": {
    "applicationdate": "출원일",
    "baseapplicationdate": "기초출원일",
    "baseregistrationdate": "기초등록일",
    "claimdate": "우선권 주장일",
    "customermatterdate": "수임일",
    "date": "날짜",
    "deadline": "기한",
    "decisiondate": "결정일",
    "duedate": "마감일",
    "filingdate": "출원일",
    "initialmadriddeadline": "최초 마감일",
    "initialpaymentdate": "최초 납부일",
    "internationalregistrationdate": "국제등록일",
    "nextdue": "다음 기한",
    "opiniondate": "의견일",
    "paymentdate": "납부일",
    "periodend": "종료일",
    "periodstart": "시작일",
    "quotedate": "견적일",
    "registrationdate": "등록일",
    "requestdate": "요청일",
    "responsedate": "회신일",
    "uploadedat": "접수일"
  },
  "moneyKeys": [
    "initialpaymentamount",
    "paymentamount",
    "contractamount",
    "patentapplicationofficialfee",
    "patentapplicationagentfee",
    "patentregistrationofficialfee",
    "patentregistrationagentfee",
    "patentpriorityapplicationofficialfee",
    "patentpriorityexaminationofficialfee",
    "patentpriorityapplicationagentfee",
    "patentpriorityregistrationofficialfee",
    "patentpriorityregistrationagentfee",
    "amount",
    "madriddomesticsupply",
    "madriddomesticvat",
    "officialamount",
    "agentamount",
    "applicationofficialfee",
    "priorityofficialfee",
    "agentfee",
    "officialfee",
    "servicefee",
    "vat",
    "etcfee"
  ],
  "writeMethods": [
    "save_admin_consultation",
    "save_client_directory",
    "send_quote",
    "save_case",
    "save_consultation",
    "save_document",
    "save_case_deadline",
    "save_quote",
    "save_standard_quote_part",
    "save_info_item"
  ]
};
export const FORM_WRITE_METHODS:string[]=rules.writeMethods;
const keyName=(key:string)=>key.replace(/_/g,'').toLowerCase();
const emailKeys=new Set(['email','clientemail','officeemail','recipientemail','localagentemail','organizermanageremail']);
const phoneKeys=new Set(['phone','clientphone','officephone','localagentcontact','organizermanagercontact','fax']);
function amount(value:any,cents=false,order=false):any {
 if(value===null||value===undefined||value==='')return '';
 if(typeof value!=='string'&&typeof value!=='number')throw Error('금액은 숫자로 입력해 주세요.');
 let raw=String(value).trim();if(!raw)return '';
 if(typeof value==='number'&&!Number.isFinite(value))throw Error('금액 범위를 확인해 주세요.');
 if(typeof value==='string'&&!/^(?:[0-9]+|[0-9]{1,3}(?:,[0-9]{3})+)(?:\.[0-9]+)?$/.test(raw))throw Error('금액의 숫자와 쉼표 형식을 확인해 주세요.');
 raw=raw.replace(/,/g,'');const number=Number(raw),maximum=order?2147483647:1e15;
 if(!Number.isFinite(number)||number<0||number>maximum)throw Error(order?'정렬 순서는 0~2147483647의 정수로 입력해 주세요.':'금액은 0~1,000,000,000,000,000 범위로 입력해 주세요.');
 if(!cents&&!Number.isInteger(number))throw Error('원화 금액과 정렬 순서는 정수로 입력해 주세요.');
 if(cents){if(number!==0&&number<0.01)throw Error('CHF 단가는 소수 둘째 자리까지 입력해 주세요.');const fraction=raw.split('.')[1]?.replace(/0+$/,'')||'';if(fraction.length>2)throw Error('CHF 단가는 소수 둘째 자리까지 입력해 주세요.');}
 return number;
}

// Primary SQL-backed fields; validation never truncates the draft.
const textLimitRules:any = {
  "save_case": [
    [
      [
        "no",
        "case_no"
      ],
      60,
      "사건번호"
    ],
    [
      [
        "clientId"
      ],
      32,
      "고객 식별자"
    ],
    [
      [
        "clientName"
      ],
      500,
      "고객명"
    ],
    [
      [
        "applicant"
      ],
      500,
      "출원인"
    ],
    [
      [
        "title",
        "displayName"
      ],
      240,
      "사건명"
    ],
    [
      [
        "registrationNo"
      ],
      80,
      "등록번호"
    ],
    [
      [
        "assignee",
        "attorney"
      ],
      50,
      "담당자"
    ],
    [
      [
        "attorney"
      ],
      80,
      "담당 변리사"
    ],
    [
      [
        "stage"
      ],
      40,
      "진행 상태"
    ],
    [
      [
        "type"
      ],
      80,
      "출원 유형"
    ],
    [
      [
        "markImageUrl"
      ],
      500,
      "표장 이미지 주소"
    ],
    [
      [
        "markText"
      ],
      240,
      "표장명"
    ],
    [
      [
        "titleEn"
      ],
      240,
      "영문 명칭"
    ],
    [
      [
        "titleKo"
      ],
      240,
      "국문명칭"
    ],
    [
      [
        "productName"
      ],
      240,
      "제품명"
    ],
    [
      [
        "applicationNo"
      ],
      80,
      "출원번호"
    ]
  ],
  "save_consultation": [
    [
      [
        "id"
      ],
      32,
      "상담 식별자"
    ],
    [
      [
        "receiptNo"
      ],
      40,
      "접수번호"
    ],
    [
      [
        "clientId"
      ],
      32,
      "고객 식별자"
    ],
    [
      [
        "title"
      ],
      200,
      "상담 제목"
    ],
    [
      [
        "clientName"
      ],
      80,
      "고객명"
    ],
    [
      [
        "consultant",
        "clientContactName"
      ],
      80,
      "고객 담당자"
    ],
    [
      [
        "clientEmail"
      ],
      120,
      "고객 이메일"
    ],
    [
      [
        "assignee"
      ],
      80,
      "담당자"
    ],
    [
      [
        "caseType"
      ],
      40,
      "상담 유형"
    ],
    [
      [
        "rightType"
      ],
      40,
      "권리 유형"
    ],
    [
      [
        "status"
      ],
      20,
      "상담 상태"
    ],
    [
      [
        "priority"
      ],
      20,
      "우선순위"
    ],
    [
      [
        "summary"
      ],
      1200,
      "상담 내용"
    ]
  ],
  "save_quote": [
    [
      [
        "id",
        "quoteNo"
      ],
      60,
      "견적번호"
    ],
    [
      [
        "caseId"
      ],
      32,
      "사건 식별자"
    ],
    [
      [
        "caseNo"
      ],
      60,
      "사건번호"
    ],
    [
      [
        "source",
        "subject"
      ],
      240,
      "사건명"
    ],
    [
      [
        "clientName"
      ],
      120,
      "고객명"
    ],
    [
      [
        "template",
        "customTemplateName"
      ],
      180,
      "견적 제목"
    ],
    [
      [
        "templateFileName"
      ],
      240,
      "견적 파일명"
    ]
  ],
  "save_standard_quote_part": [
    [
      [
        "id"
      ],
      32,
      "견적 항목 식별자"
    ],
    [
      [
        "name"
      ],
      200,
      "견적 항목명"
    ],
    [
      [
        "partType"
      ],
      20,
      "견적 항목 유형"
    ]
  ],
  "save_info_item": [
    [
      [
        "id"
      ],
      32,
      "자료 식별자"
    ],
    [
      [
        "title",
        "name",
        "fileName"
      ],
      200,
      "자료 제목"
    ]
  ],
  "save_client_directory": [
    [
      [
        "clientId"
      ],
      32,
      "고객 식별자"
    ],
    [
      [
        "sourceId"
      ],
      32,
      "연락처 식별자"
    ],
    [
      [
        "email"
      ],
      120,
      "이메일"
    ]
  ],
  "save_document": [
    [
      [
        "id"
      ],
      32,
      "서류 식별자"
    ],
    [
      [
        "name",
        "fileName"
      ],
      180,
      "서류명"
    ],
    [
      [
        "fileName"
      ],
      240,
      "첨부 파일명"
    ],
    [
      [
        "category"
      ],
      60,
      "서류 종류"
    ]
  ]
};
function validateTextLimits(payload:any, method:string):void {
  const data=method==='save_document'&&payload.document&&typeof payload.document==='object'&&!Array.isArray(payload.document)?payload.document:payload;
  const checks:any[]=[...(textLimitRules[method]||[])];
  if(method==='save_quote'&&data.authoringMode==='upload')checks.push([['customTemplateName','templateFileName'],180,'견적 제목']);
  if(method==='save_client_directory') {
    const limit:any=({client:120,contact:80,applicant:500,consultant:80} as any)[String(data.sourceType||'').trim()];
    if(limit)checks.push([['name'],limit,'이름']);
  }
  for(const [keys,limit,label] of checks) {
    for(const key of keys) {
      if(data[key]===null||data[key]===undefined)continue;
      const value=String(data[key]).trim();
      if(!value)continue;
      if(Array.from(value).length>limit)throw Error(label+'은(는) '+limit+'자 이하로 입력해 주세요.');
      break;
    }
  }
}

export function validateFormDraft(payload:any,method=''):{value:any,error:string} {
 try {
  if(!payload||typeof payload!=='object'||Array.isArray(payload))throw Error('입력값을 확인해 주세요.');
    validateTextLimits(payload,method);
  const walk=(value:any):any=>{
   if(Array.isArray(value))return value.map(walk);
   if(!value||typeof value!=='object'||value instanceof Date)return value;
   const result=Object.fromEntries(Object.entries(value).map(([key,item]:[string,any])=>{
    const normalized=keyName(key);let output=item;
    if(emailKeys.has(normalized)||phoneKeys.has(normalized)){
     if(item===null||item===undefined||item==='')output='';
     else if(typeof item!=='string')throw Error('연락처 또는 이메일 형식을 확인해 주세요.');
     else if(emailKeys.has(normalized)){if(item.trim()&&!validEmail(item))throw Error('이메일 형식을 확인해 주세요.');output=item.trim();}
     else{output=normalizePhone(item);if(output===null)throw Error('연락처 형식을 확인해 주세요.');}
    }else if(normalized==='paymenttermyears'){if(![5,10,'5','10'].includes(item))throw Error('갱신 납부 주기는 5년 또는 10년을 선택해 주세요.');output=Number(item);
        }else if(Object.prototype.hasOwnProperty.call(rules.dateLabels,normalized)&&(normalized!=='uploadedat'||method==='save_document')){
     if(item===null||item===undefined||item==='')output='';
     else{
      const label=(rules.dateLabels as any)[normalized];if(typeof item!=='string'||!/^\d{4}-\d{2}-\d{2}$/.test(item.trim()))throw Error(label+'을(를) YYYY-MM-DD 형식으로 입력해 주세요.');
      const text=item.trim(),[year,month,day]=text.split('-').map(Number);const date=new Date(0);date.setUTCFullYear(year,month-1,day);date.setUTCHours(0,0,0,0);
      if(year<1||date.getUTCFullYear()!==year||date.getUTCMonth()!==month-1||date.getUTCDate()!==day)throw Error(label+'의 실제 날짜를 확인해 주세요.');output=text;
     }
    }else if(rules.moneyKeys.includes(normalized)||normalized==='unitchf'||normalized==='sortorder')output=amount(item,normalized==='unitchf',normalized==='sortorder');
    else output=walk(item);
    return [key,output];
   }));
   const byname=Object.fromEntries(Object.entries(result).map(([k,v])=>[keyName(k),v]));
   for(const [first,last,label] of [['periodstart','periodend','종료일은 시작일보다 빠를 수 없습니다.'],['applicationdate','registrationdate','등록일은 출원일보다 빠를 수 없습니다.'],['baseapplicationdate','baseregistrationdate','기초등록일은 기초출원일보다 빠를 수 없습니다.']])if(byname[first]&&byname[last]&&byname[first]>byname[last])throw Error(label);
   return result;
  };
  return {value:walk(payload),error:''};
 }catch(error:any){return {value:payload,error:error?.message||'입력값을 확인해 주세요.'};}
}
